export const LINKEDIN = 'https://www.linkedin.com/company/pints-app/'
export const TELEGRAM = 'https://t.me/pintschat'
export const TWITTER = 'https://twitter.com/WithPints'
export const INSTAGRAM = 'https://www.instagram.com/pintsapp/'
export const BROKER_INFO = 'https://brokercheck.finra.org/firm/summary/288202'
export const SIPC_INFO = 'https://www.sipc.org/about-sipc/'
